import { Button as Btn } from '@chakra-ui/react';

export const Button = Btn;
